import { Notify } from '@flexisaf/flexibull2';
import { put, takeLatest } from 'redux-saga/effects';
import httpClient from 'utils/http-client';
import { handleError } from 'utils/utils';
import { editSingleRatingFail, editSingleRatingSuccess, fetchRatingStart } from '../actions';
import earlyYearsActionTypes from '../types';

export function* editRateRemark({ payload }) {
  const { id, data } = payload;
  try {
    const response = yield httpClient.put(
      `/trait-configuration/trait-ratings/definitions/${id}`,
      data,
    );
    yield put(editSingleRatingSuccess(response.data));
    yield put(fetchRatingStart());
    Notify('Rating edited succesfully', { position: 'top-right' });
  } catch (error) {
    yield put(editSingleRatingFail(error.fail));
    const err = handleError(error);
  }
}

export function* onEditRateRemarkStart() {
  yield takeLatest(earlyYearsActionTypes.EDIT_SINGLE_RATE_START, editRateRemark);
}
